// extracted by mini-css-extract-plugin
module.exports = {"container":"contact-module--container--1JMah","introText":"contact-module--intro-text--1f1FS","prose":"contact-module--prose--n16Dc"};